import CountryStates from './CountryStates';

export default CountryStates;


// WEBPACK FOOTER //
// ./src/scenes/Countries/CountryDetail/components/CountryStates/index.tsx